import { CommitementDetails, RolesEnum } from "../../../../../types";
import {
    computeCompletenessComReqs,
    computeCompletenessDocsInComReq,
    computeInstrcutedDocsInComReq,
    computeInstructedComReqs,
} from "../../utils";

export function useCommitment(
    commitmentInfos: CommitementDetails | null,
    userRoleId: number
) {
    if (commitmentInfos) {
        const computeCircualProgressRatio = (
            commitmentInfos: CommitementDetails
        ) => {
            const computeCircualProgressRatioByUserRole = () => {
                if ([RolesEnum.CLIENT, RolesEnum.ADMIN_RESEAU, RolesEnum.ADMIN_REGION].includes(userRoleId)) {
                    return computeCompletenessDocsInComReq(
                        commitmentInfos.commitmentRequirements
                    );
                }
                if (
                    [
                        RolesEnum.INSTRUCTEUR,
                        RolesEnum.ADMIN,
                        RolesEnum.SYNERPA,
                    ].includes(userRoleId)
                ) {
                    return computeInstrcutedDocsInComReq(
                        commitmentInfos.commitmentRequirements
                    );
                }
                return 0;
            };

            const d = computeCircualProgressRatioByUserRole();
            return d * 100;
        };

        const circualProgressRatio =
            computeCircualProgressRatio(commitmentInfos);

        const computRatioNumByUserRoleId = () => {
            if ([RolesEnum.CLIENT, RolesEnum.ADMIN_RESEAU, RolesEnum.ADMIN_REGION].includes(userRoleId)) {
                return computeCompletenessComReqs(
                    commitmentInfos.commitmentRequirements
                ).length;
            }
            if (
                [
                    RolesEnum.INSTRUCTEUR,
                    RolesEnum.ADMIN,
                    RolesEnum.SYNERPA,
                ].includes(userRoleId)
            ) {
                return computeInstructedComReqs(
                    commitmentInfos.commitmentRequirements
                ).length;
            }
            return 0;
        };

        const ratio = {
            num: computRatioNumByUserRoleId(),
            den: commitmentInfos.commitmentRequirements.length,
        };

        return { ratio, circualProgressRatio };
    }
}
